import { useState } from 'react';
import TellStoryLanguage from './_components/language/TellStoryLanguage';
import {
  ITellStoryDetailRes,
  ITellStoryLanguageRes,
  ITellStoryStoriesRes,
  ITellStoryTopicsRes,
} from 'src/core/repo/tellStory/type';
import {
  useChildrenList,
  useSubmitTellStory,
  useTellStoryDetail,
  useTellStoryStories,
  useTellStoryTopics,
} from 'src/core/repo/tellStory/useCase';
import ChildrenList from './_components/childrenList/ChildrenList';
import { childListResponse } from 'src/core/repo/child/types';
import TopicList from './_components/topicList/TopicList';
import StoriesList from './_components/storiesList/StoriesList';
import ImageList from './_components/imageList/ImageList';
import axios from 'axios';

const TellStoryPage = () => {
  const [step, setStep] = useState<number | null>(0);
  const [selectedLanguage, setSelectedLanguage] =
    useState<ITellStoryLanguageRes | null>(null);
  const [selectedChildren, setSelectedChildren] =
    useState<childListResponse | null>(null);
  const [selectedTopic, setSelectedTopic] =
    useState<ITellStoryTopicsRes | null>(null);
  const [selectedStory, setSelectedStory] =
    useState<ITellStoryStoriesRes | null>(null);
  const [generatedText, setGeneratedText] = useState('');
  const [file, setFile] = useState<File | null>(null);

  const {
    mutate: mutateChildList,
    data: childrenList,
    isLoading: isLoadingChildrenList,
  } = useChildrenList();

  const {
    mutateAsync: mutateTopicList,
    data: topicList,
    isLoading: isLoadingTopicList,
  } = useTellStoryTopics();

  const {
    mutate: mutateStories,
    isLoading,
    data: stories,
  } = useTellStoryStories();

  const { mutateAsync: submitTellStory } = useSubmitTellStory();

  const {
    mutate: mutateTellStoryDetail,
    isLoading: isLoadingTellStoryDetail,
    data: storyDetail,
  } = useTellStoryDetail();

  const handleSelectLanguage = (language: ITellStoryLanguageRes) => {
    setSelectedLanguage(language);
    mutateChildList();
    setStep(1);
  };

  const handleSelectChildren = (children: childListResponse) => {
    setSelectedChildren(children);
    setStep(2);
    console.log('assa');

    if (selectedLanguage?.LanguageID) {
      mutateTopicList({
        lang_id: selectedLanguage?.LanguageID,
        child_id: children.ChildID,
      });
    }
  };

  const handleSelectTopic = (topic: ITellStoryTopicsRes) => {
    setSelectedTopic(topic);
    setStep(3);
    if (selectedChildren && selectedLanguage && selectedChildren) {
      mutateStories({
        child_id: selectedChildren.ChildID,
        lang_id: selectedLanguage.LanguageID,
        topic_id: topic.TrainingTopicID,
      });
    }
  };

  const handleSelectStoryImage = (story: ITellStoryStoriesRes) => {
    if (selectedChildren && story) {
      setSelectedStory(story);
      setStep(4);
      mutateTellStoryDetail({
        child_id: selectedChildren?.ChildID,
        story_id: story.StoryBankID,
      });
    }
  };

  const handleSubmit = async (
    stories: ITellStoryDetailRes[],
    generatedTextById: Record<number, string>,
  ) => {
    // فقط استوری‌هایی که متن دارن فیلتر کن
    const validStories = stories.filter((story) =>
      generatedTextById[story.StoryContentID]?.trim(),
    );

    if (validStories.length === 0) {
      console.warn('هیچ استوری‌ای متنی نداره!');
      return;
    }

    // چون child_id، story_id و language معمولاً بین همه مشترکن
    const firstStory = validStories[0];

    // آماده‌سازی آرایه‌ی story_text
    const story_text = validStories.map((story) => ({
      story_content_id: story.StoryContentID,
      vorder: story.VOrder ?? 0,
      text: generatedTextById[story.StoryContentID] || '',
    }));

    const payload = {
      story_id: firstStory.StoryID,
      child_id: firstStory.ChildID,
      language: firstStory.LangTitle,
      story_text,
    };

    submitTellStory(payload);
  };

  return (
    <div>
      {step === 0 ? (
        <TellStoryLanguage handleClick={handleSelectLanguage} />
      ) : step === 1 ? (
        <ChildrenList
          items={childrenList?.data}
          isLoading={isLoadingChildrenList}
          onSelect={handleSelectChildren}
        />
      ) : step === 2 ? (
        <TopicList
          onBack={() => setStep(1)}
          language={selectedLanguage?.Lang ?? 'English'}
          handleSelectTopic={handleSelectTopic}
          isLoading={isLoadingTopicList}
          items={topicList}
        />
      ) : step === 3 ? (
        <ImageList
          setStep={setStep}
          stories={stories}
          isLoading={isLoading}
          onSelect={handleSelectStoryImage}
        />
      ) : step === 4 ? (
        <StoriesList
          setStep={setStep}
          isLoading={isLoadingTellStoryDetail}
          stories={storyDetail}
          setFile={setFile}
          setGeneratedText={setGeneratedText}
          generatedText={generatedText}
          selectedStory={selectedStory}
          selectedChildren={selectedChildren}
          handleSubmit={(stories, generatedTextById) => {
            handleSubmit(stories, generatedTextById);
          }}
        />
      ) : null}
    </div>
  );
};

export default TellStoryPage;
